module.exports = __webpack_public_path__ + "static/media/iphone5_splash.41839e64.png";